import {
  faCloudUploadAlt,
  faEuroSign,
  faExclamationTriangle,
  faInfoCircle,
  faLock,
  faUnlock,
} from "@fortawesome/free-solid-svg-icons";
import Axios from "axios";
import React, { useCallback, useContext, useState } from "react";
import {
  MEASURE_STATE_BILLING,
  MEASURE_STATE_DECLINED,
  WORKFLOW_INFO,
  MEASURE_STATE_PROCESS,
  MEASURE_STATE_RDB_SYNC,
  MEASURE_STATE_SUCCESS,
  TMeasureQualityStates,
} from "../../config/workflow";
import { TWorkflowType } from "../../hooks/useLastHistoryStatus";
import { TCompanyType } from "../../store/user/types";
import { CommentModal } from "./CommentModal/CommentModal";
import { WorkflowButton } from "./WorkflowButton/WorkflowButton";
import { SmbToastContext, TSmbToast } from "../../context/SmbTabsContext";
type TQualityButtonsProps = {
  workflowType: TWorkflowType;
  lastState: TMeasureQualityStates;
  isValid: boolean;
  companyType?: TCompanyType;
  buildingId: number;
  forceFetch?: () => void;
  qsOffice?: number | null;
  companyId?: number | null;
};

export const QualityButtons: React.FC<TQualityButtonsProps> = ({
  workflowType,
  lastState,
  companyType,
  isValid,
  buildingId,
  forceFetch,
  qsOffice,
  companyId,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [workflowState, setWorkflowState] = useState<TMeasureQualityStates>();
  const { addToast } = useContext(SmbToastContext);
  const onSubmit = useCallback(
    async (state: TMeasureQualityStates, comment = "") => {
      if (!buildingId || companyType === "firma") {
        return;
      }

      let message: TSmbToast = {
        message: "Status erfolgreich geändert",
        intent: "success",
        autoClose: 3000,
      };

      try {
        await Axios.post(`/workflow/measure/qsCheck/${buildingId}/`, {
          workflowState: state,
          comment,
        });
      } catch (e) {
        message = {
          message: "Status konnte nicht geändert werden",
          intent: "error",
          autoClose: 0,
        };
      }

      if (forceFetch) {
        forceFetch();
      }

      if (addToast) {
        addToast(message);
      }

      setWorkflowState(undefined);
    },
    [companyType, buildingId, forceFetch, addToast]
  );

  const addComment = useCallback(
    (comment: string) => {
      if (!workflowState) {
        setOpen(false);
        return;
      }
      setOpen(false);
      onSubmit(workflowState, comment);
    },
    [workflowState, onSubmit, setOpen]
  );

  if (
    workflowType !== "qsCheck" ||
    (qsOffice && qsOffice !== companyId) ||
    (!qsOffice && companyType !== "smb") ||
    !isValid ||
    lastState === MEASURE_STATE_DECLINED
  ) {
    return null;
  }

  return (
    <div>
      <CommentModal
        isOpen={isOpen}
        onClose={() => {
          setOpen(false);
          setWorkflowState(undefined);
        }}
        onSubmit={addComment}
      />
      <WorkflowButton
        hidden={companyType === "amt"}
        text="Abgerechnet"
        icon={faEuroSign}
        disabled={lastState !== MEASURE_STATE_RDB_SYNC}
        onClick={() => {
          setOpen(true);
          setWorkflowState(MEASURE_STATE_BILLING);
        }}
      />
      <WorkflowButton
        hidden={companyType === "amt"}
        text="RDB-Sync"
        icon={faCloudUploadAlt}
        disabled={lastState !== MEASURE_STATE_SUCCESS}
        onClick={() => {
          setOpen(true);
          setWorkflowState(MEASURE_STATE_RDB_SYNC);
        }}
      />
      <WorkflowButton
        text="Information"
        icon={faInfoCircle}
        disabled={!lastState || lastState >= 99}
        onClick={() => {
          setOpen(true);
          setWorkflowState(WORKFLOW_INFO);
        }}
      />
      <WorkflowButton
        intent="danger"
        text="Fehlerhaft"
        icon={faExclamationTriangle}
        disabled={!lastState || lastState >= 99}
        onClick={() => {
          setOpen(true);
          setWorkflowState(MEASURE_STATE_DECLINED);
        }}
      />
      <WorkflowButton
        text="Erfolgreich"
        intent="success"
        icon={faLock}
        disabled={!lastState || lastState >= 99}
        onClick={() => onSubmit(MEASURE_STATE_SUCCESS)}
      />
      <WorkflowButton
        text="Starten"
        icon={faUnlock}
        disabled={!!lastState}
        onClick={() => onSubmit(MEASURE_STATE_PROCESS)}
      />
    </div>
  );
};
